import * as ReactRedux from 'react-redux';
import { AppState } from '../app/app.types';
import ReportComponent from './ReportComponent';
import { push } from 'react-router-redux';
import { paths } from '../app/app.routes';
import { getPackageReport, getPackages } from './Actions';

const mapDispatchToProps = (dispatch: Function) => {
  return {
    toDashboard: () => dispatch(push(paths.dashboard)),
    getPackageReport: (year: number, month: number) => dispatch(getPackageReport(year, month)),
    getPackages: () => dispatch(getPackages())
  };
};

const mapStateToProps = (state: AppState) => {
  return {
    authState: state.authState,
    adminState: state.adminState,
    packageState: state.packageState,
    businessState: state.businessState,
  };
};

const Report = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(ReportComponent);

export default Report;



// WEBPACK FOOTER //
// ./src/mms-package/Report.tsx